/*
 * @Description:
 * @Author: Mark
 * @Date: 2021-07-15 14:30:24
 * @LastEditors: Mark
 * @LastEditTime: 2021-07-16 16:51:33
 * @FilePath: /ecom-client/src/utils/format.ts
 */
import { isNotNull } from './mUtil'

const formatReport = (data: any) => {
  const { dslData, moduleId } = data
  const content = []
  const originData = dslData.length > 1 ? formatData(dslData) : dslData[0].data
  content.push(...EachData(originData, moduleId))
  // for (const [key, value] of Object.entries(originData)) {
  //   const val: any = value
  //   if (key === 'slot_id') {
  //     content.push({
  //       $slot_position: val.toString(),
  //       mod_id: moduleId,
  //       $url: originData['jumpUrl'],
  //     })
  //   } else if (!isNaN(+key)) {
  //     content.push(addItem({ index: val.slot_id ?? 1, val }, moduleId))
  //   } else if (key === 'items') {
  //     for (const item of val) {
  //       const isNumber = Object.keys(item).some((i: string | number) => {
  //         console.log(i)
  //         return !isNaN(+i)
  //       })

  //       if (isNumber) {
  //         const list: Array<any> = Object.values(item)
  //         for (const k of list) {
  //           content.push(addItem({ index: k.slot_id ?? 1, val: k }, moduleId))
  //         }
  //       } else {
  //         content.push(
  //           addItem({ index: item.slot_id ?? 1, val: item }, moduleId)
  //         )
  //       }
  //     }
  //   }
  // }

  return content
}

const EachData = <T = any>(originData: any, moduleId: string): Array<T> => {
  const content = []
  for (const [key, value] of Object.entries(originData)) {
    const val: any = value
    if (key === 'slot_id') {
      content.push({
        $slot_position: val.toString(),
        mod_id: moduleId,
        $url: originData['jumpUrl'],
      })
    } else if (!isNaN(+key)) {
      content.push(addItem({ index: val.slot_id ?? 1, val }, moduleId))
    } else if (key === 'items') {
      for (const item of val) {
        const isNumber = Object.keys(item).every((i: string | number) => {
          return !isNaN(+i)
        })
        if (isNumber) {
          const list: Array<any> = Object.values(item)
          for (const k of list) {
            content.push(addItem({ index: k.slot_id ?? 1, val: k }, moduleId))
          }
        } else {
          content.push(...EachData(item, moduleId))
        }
      }
    }
  }
  return content
}

const formatData = (data: any) => {
  const obj: any = {}
  for (const item of data) {
    for (const [k, v] of Object.entries(item.data)) {
      if (!isNaN(+k)) {
        if (obj['items']) {
          obj['items'].push(v)
        } else {
          obj['items'] = [v]
        }
      } else {
        obj[k] = v
      }
    }
  }
  return obj
}

/**
 * @param param 数据源
 * @param moduleId 模块id
 * @returns 元素曝光
 */
const addItem = ({ index, val }: any, moduleId: number | string) => {
  const obj: any = {}

  obj.$slot_position = index.toString()
  obj.mod_id = moduleId

  //H5外链地址
  if (!val.item_type && !val.goodsCatID) {
    obj.$url = val.jumpUrl
  }

  //商品
  if (val.item_type === 1 && val.item_id) {
    obj.goods_id = val.item_id + ''
    obj.shop_price = val.shop_price
    isNotNull(val.fdParams) && (obj.lob = val.fdParams)
  }

  //搜索跳转
  if (val.item_type === 7) {
    obj.$element_content = val.title
  }

  return obj
}

export default formatReport
